// Site-wide Constants for Leisure Wellness Naples

// Tropical Logo with palm trees, waves, sun - for Header and Footer
export const TROPICAL_LOGO = 'https://customer-assets.emergentagent.com/job_viking-wellness-pool/artifacts/70g7scv1_unnamed.png';

// Text-only Logo - for use everywhere else (popups, pages, etc.)
export const TEXT_LOGO = 'https://customer-assets.emergentagent.com/job_facb4f26-a2e6-4442-86c1-fb37e051f83a/artifacts/ztls5pyw_ad802576-1ba4-4850-98b3-f8a068f6bea7.png';

// About Page Image (Grand Opening)
export const ABOUT_IMAGE = 'https://customer-assets.emergentagent.com/job_american-spa-portal/artifacts/iri86zu2_549423966_122190087680361664_6940928450155468082_n.jpg';

// Lanai Special Promo Image (Homepage popup) - The Lanai Special 110V Plug & Go
export const TRY_BEFORE_YOU_BUY_IMAGE = '/images/try-before-you-buy-popup.png';
export const TRY_BEFORE_YOU_BUY_URL = '/contact';

// Buyers Guide PDFs (downloadable from Wellness / Brochures / Saunas pages)
export const BUYERS_GUIDES = {
  sauna: 'https://customer-assets.emergentagent.com/job_wellness-experts/artifacts/a2d0nr5v_leisure-wellness-naples-sauna-buying-guide_3%20copy.pdf',
  hotTub: 'https://customer-assets.emergentagent.com/job_wellness-experts/artifacts/8e7w4bfj_leisure-wellness-naples-hot-tub-buying-guide.pdf',
};

// External Partner / Profile Links
export const NATURAL_ROCK_SPAS_URL = 'https://naturalrockspas.com/';
export const GOOGLE_BUSINESS_URL = 'https://www.google.com/search?q=leisure+wellness+spa+naples+florida&rlz=1C5CHFA_enUS1182US1182&oq=leisure+welln&gs_lcrp=EgZjaHJvbWUqCAgAEEUYJxg7MggIABBFGCcYOzIGCAEQRRg7MgwIAhAjGCcYgAQYigUyBggDEEUYOTIKCAQQABgKGBYYHjIICAUQABgWGB4yBggGEEUYPDIGCAcQRRg90gEIMjE3NWowajeoAgCwAgA&sourceid=chrome&ie=UTF-8#lrd=0x88db1fe25c6cc5cd:0x2b5aecc6d644fcac,3,,,,';

// Free Items Images (Cover, Cover Lifter, Steps, Chemicals)
export const FREE_ITEMS_IMAGES = {
  cover: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/shtl8amd_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GRE.avif',
  coverLifter: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/x4bjk1d4_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GREENVILLE%20SC%2C%20SWIM%20SPAS%2C%20SWIM%20SPAS%20IN%20GREENVILLE%20SC%2C.avif',
  steps: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/jvkm6wp4_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GREENVILLE%20SC%2C%20SWIM%20SPAS%2C%20SWIM%20SPAS%20IN%20GREENVILLE%20SC%2C-1.avif',
  chemicals: 'https://customer-assets.emergentagent.com/job_river-spa-catalog/artifacts/qcp7yp8w_SWIM%20SPAS%20SIMPSONVILLE%20SC%2C%20SWIM%20SPAS%20GREENVILLE%20SC%2C%20SWIM%20SPAS%2C%20SWIM%20SPAS%20IN%20GREENVILLE%20SC%2C-2.avif',
};

// Assets URLs
export const ASSETS = {
  logo: TEXT_LOGO,                    // Default logo (text only) for general use
  oldLogo: TEXT_LOGO,                 // Old logo for backward compatibility
  tropicalLogo: TROPICAL_LOGO,        // Tropical logo for header and footer
  headerLogo: TROPICAL_LOGO,          // Logo for header
  footerLogo: TROPICAL_LOGO,          // Logo for footer
  heroVideo: 'https://customer-assets-jt897jd0.emergentagent.net/job_product-pricing-27/artifacts/0eqytheo_Leisure%20Wellness%20Naples%20%E2%80%94%20Play%20Hard%2C%20Recover%20Harder-2.mp4',
  wetTestVideo: 'https://customer-assets.emergentagent.com/job_american-spa-portal/artifacts/atx9u9gd_SnapSave_App_1262194805786001_1080p.mp4',
  jingle: 'https://customer-assets.emergentagent.com/job_e23f927f-0a4b-43ea-96db-a0ca9339796e/artifacts/80qfrl8e_SnapSave_App_1155304596774970_1080p.mp3',
  aboutImage: ABOUT_IMAGE,
  freeItems: FREE_ITEMS_IMAGES,
};

// Contact Information - Naples, FL
export const CONTACT = {
  phone: '239-517-3135',
  email: 'info@leisurewellnessnaples.com',
  address: '6000 Taylor Rd, Suite 8, Naples, FL 34109',
  hours: "Can't make these hours? Call us and we'll set up an appointment that works for you.",
  detailedHours: [
    { day: 'Monday', hours: '10am-6pm' },
    { day: 'Tuesday', hours: '10am-6pm' },
    { day: 'Wednesday', hours: '10am-8pm (Late Night)' },
    { day: 'Thursday', hours: '10am-6pm' },
    { day: 'Friday', hours: '10am-6pm' },
    { day: 'Saturday', hours: '10am-5pm' },
    { day: 'Sunday', hours: '12pm-4pm' },
  ],
  serviceAreas: ['Naples, FL', 'Marco Island, FL', 'Bonita Springs, FL', 'Estero, FL', 'Fort Myers, FL', 'Cape Coral, FL'],
};

// Contact Information - Greenville
export const CONTACT_GREENVILLE = {
  phone: '(864) 555-1234', // Update with actual Greenville phone
  email: 'info@leisurewellnessgreenville.com', // Update with actual Greenville email
  address: 'Greenville, SC', // Update with actual Greenville address
  hours: 'Call us to schedule an appointment.',
  detailedHours: [
    { day: 'Monday', hours: '10am-6pm' },
    { day: 'Tuesday', hours: '10am-6pm' },
    { day: 'Wednesday', hours: '10am-8pm' },
    { day: 'Thursday', hours: '10am-6pm' },
    { day: 'Friday', hours: '10am-6pm' },
    { day: 'Saturday', hours: '10am-6pm' },
    { day: 'Sunday', hours: 'Closed' },
  ],
  serviceAreas: ['Greenville, SC', 'Simpsonville, SC', 'Mauldin, SC', 'Greer, SC', 'Spartanburg, SC', 'Anderson, SC'],
};

export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/leisurewellnessnaples/',
  facebook: 'https://www.facebook.com/profile.php?id=61583729330315',
  youtube: 'https://www.youtube.com/@LEISUREWELLNESSNAPLES',
};

// Viking Spas Warranty Information
export const VIKING_SPAS_WARRANTY = {
  coverWarranty: '3 Year Cover Warranty',
  shellWarranty: 'Lifetime Shell Warranty',
  plumbingElectric: '3 Years Plumbing & Electric',
  shellStructure: '5 Years Shell Structure',
  fullDescription: 'Viking Spas stands behind their products with industry-leading warranty coverage. Your investment is protected with comprehensive coverage including a Lifetime Shell Warranty, 5 Years Shell Structure, 3 Years Plumbing & Electric, and a 3 Year Cover Warranty.',
};

// Wellness Content
export const WELLNESS_BENEFITS = [
  {
    id: 'hydrotherapy',
    title: 'Hydrotherapy: The Real Deal',
    description: 'Hydrotherapy has been around since ancient civilizations. Today\'s hot tubs come with spa jets that do wonders like improving circulation, helping your muscles recover, and lowering anxiety.',
    icon: 'Droplets'
  },
  {
    id: 'sleep',
    title: 'Sleep Like a Baby',
    description: 'Tossing and turning at night? A hot tub might be the fix you need. The warm water and jets help melt away stress and loosen up muscles, so you can sleep like a rock.',
    icon: 'Moon'
  },
  {
    id: 'stress',
    title: 'Stress? Meet Your Match',
    description: 'Hot water improves circulation, calms your nerves, and reduces pain. Soak in hot water, and your body releases endorphins, helping you unwind from the day and relax.',
    icon: 'Heart'
  },
  {
    id: 'family',
    title: 'Family Time, But Better',
    description: 'Quality family time is priceless. Jump in the hot tub for some bonding time away from screens and distractions. It\'s a terrific way to make memories while boosting your well-being.',
    icon: 'Users'
  },
  {
    id: 'arthritis',
    title: 'Arthritis Relief, Naturally',
    description: 'The heat and gentle massage of water therapy help ease joint stiffness and pain. Plus, regular use can reduce inflammation and increase muscle flexibility, so you can stay active and feel good.',
    icon: 'Activity'
  }
];
